export default {
  text1: 'Potřebujete peníze skutečně rychle?<br><b>Urychlete průběh žádosti!</b>',
  text2: 'Pokračujte prosím ve vyplnění.',
  button: 'Pokračovat',
  errors: {
    default: 'Nedaří se pokračovat ve formuláři. Zkuste to, prosím, znovu.',
  },

  fullName: 'Jméno a příjmení',
  address: 'Adresa',
  phone: 'Telefonní číslo',
  email: 'Email',
  loanValue: 'Jistina',
  realtyAddress: 'Adresa nemovitosti',
  aboutYouInfo: 'Info o vás',
};
